import axios from "axios";

export const API = axios.create({
  baseURL: "/api/",
  withCredentials: true,
  xsrfCookieName: "csrftoken",
  xsrfHeaderName: "X-CSRFToken",
});

// Ensure CSRF token header is attached to all mutation requests
API.interceptors.request.use((config) => {
  const method = config.method ? config.method.toLowerCase() : "";
  if (["post", "put", "patch", "delete"].includes(method)) {
    const match = document.cookie.match(/csrftoken=([^;]+)/);
    if (match && !config.headers["X-CSRFToken"]) {
      config.headers["X-CSRFToken"] = match[1];
    }
  }
  return config;
});